import { Navigate, Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import {
  BusinessProfileRouter,
  BusinessProfileRoutes,
  BusinessProfileStepsRouter,
} from 'pages/settings/pages/compliance/pages/businessProfile'
import { CompliancePage } from 'pages/settings/pages/compliance/ui/compliancePage'
import {
  QuestionnaireRouter,
  QuestionnaireRoutes,
} from 'pages/settings/pages/compliance/pages/questionnaire'
import { ComplianceLayout } from 'pages/settings/pages/compliance/layout/complianceLayout'
import { ComplianceAccessLayout } from 'pages/settings/pages/compliance/layout/complianceAccessLayout'
import { CompliancePageLayout } from 'pages/settings/pages/compliance/layout/compliancePageLayout'
import {
  TollFreeMainPageRouter,
  TollFreeRootRouter,
  TollFreeRoutes,
} from 'pages/settings/pages/compliance/pages/tollFree'
import { CallingPage, CallingRoutesSteps } from 'pages/settings/pages/compliance/pages/calling'
import {
  LocalNumbersRouter,
  LocalNumbersRoutes,
  LocalNumbersStepsRouter,
} from 'pages/settings/pages/compliance/pages/localNumbers'
import { useComplianceLayerContext } from 'pages/settings/pages/compliance/context'
import { CallingStepsRouter } from 'pages/settings/pages/compliance/pages/calling/route/CallingStepsRouter'
import { ComplianceAccessRootLayout } from 'pages/settings/pages/compliance/layout/complianceAccessRootLayout'
import {
  InternationalPage,
  InternationalRoutes,
} from 'pages/settings/pages/compliance/pages/international'
import { InternationalStepsRouter } from 'pages/settings/pages/compliance/pages/international/route/InternationalStepsRouter'
import { Upgrade10DLCPackageRoutes } from 'pages/settings/pages/compliance/pages/upgrade10DLCPackage/route/type'
import { Upgrade10DLCPackageRouter } from 'pages/settings/pages/compliance/pages/upgrade10DLCPackage'
import { SettingsPath } from 'pages/settings/route/settingsPath.ts'

const NavigateIndex = observer(() => {
  const store = useComplianceLayerContext()

  if (store.summary?.isRequiredTollFree) return <Navigate to={TollFreeRoutes.root} replace />

  return <Navigate to={BusinessProfileRoutes.root} replace />
})

const QuestionnaireGuard = observer(() => {
  const store = useComplianceLayerContext()

  if (store.isUKCountry) return <Navigate to={store.internationalRegulatoryBundlesPath} replace />

  return <QuestionnaireRouter />
})

const Upgrade10DLCPackageRouterGuard = observer(() => {
  const store = useComplianceLayerContext()

  if (!store.isCanUpgradePackage)
    return <Navigate to={`/${SettingsPath.compliance.localNumbers.root}`} replace />

  return <Upgrade10DLCPackageRouter />
})

export const ComplianceRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<ComplianceAccessRootLayout />}>
        <Route element={<ComplianceLayout />}>
          <Route element={<ComplianceAccessLayout />}>
            <Route element={<CompliancePageLayout />}>
              <Route index element={<NavigateIndex />} />
              <Route path={'/'} element={<CompliancePage />} />
              <Route path={BusinessProfileRoutes.root} element={<BusinessProfileRouter />} />
              <Route path={LocalNumbersRoutes.root} element={<LocalNumbersRouter />} />
              <Route path={TollFreeRoutes.root} element={<TollFreeMainPageRouter />} />
              <Route path={CallingRoutesSteps.root} element={<CallingPage />} />
              <Route path={InternationalRoutes.root} element={<InternationalPage />} />
            </Route>
          </Route>

          <Route
            path={`${BusinessProfileRoutes.root}/*`}
            element={<BusinessProfileStepsRouter />}
          />
          <Route path={`${LocalNumbersRoutes.root}/*`} element={<LocalNumbersStepsRouter />} />
          <Route path={`${TollFreeRoutes.root}/*`} element={<TollFreeRootRouter />} />
          <Route path={`${CallingRoutesSteps.root}/*`} element={<CallingStepsRouter />} />
          <Route path={`${QuestionnaireRoutes.root}/*`} element={<QuestionnaireGuard />} />
          <Route path={`${InternationalRoutes.root}/*`} element={<InternationalStepsRouter />} />
          <Route
            path={`${Upgrade10DLCPackageRoutes.root}/*`}
            element={<Upgrade10DLCPackageRouterGuard />}
          />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
